<div class="container-visualizacao-sc" *ngIf="!isFormOpen">
    <div class="row container-visualizacao-sc-options">
        <div class="col-12">
            <button type="button" class="btn btn-link" (click)="insert()"><i class="fas fa-plus" aria-hidden="true"></i> Novo Endereço</button>                 
        </div>
    </div>
    <div class="row container-visualizacao-sc-table">
        <div class="col-12">
            <table class="table table-striped table-hover datatables" id="tableLeadEnderecos">
                <thead>
                        <tr>
                            <th class="col-options"></th>
                            <th class="col-logradouro">Logradouro</th>
                            <th class="col-bairro">Bairro</th>
                            <th class="col-numero">Número</th>
                            <th class="col-cidade">Cidade</th>
                        </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let entity of entities; let i = index">
                        <td class="col-options">
                            <a (click)="edit(i)"><i class="fas fa-pencil-alt" aria-hidden="true"></i></a>
                            <a (click)="delete(i)"><i class="far fa-trash-alt" aria-hidden="true"></i></a>
                        </td>
                        <td class="col-logradouro">{{entity.logradouro}}</td>
                        <td class="col-bairro">{{entity.bairro}}</td>
                        <td class="col-numero">{{entity.numero}}</td>
                        <td class="col-cidade">{{entity.idCidade}}</td>
                    </tr>
                </tbody>
            </table>                     
        </div>
    </div>    
</div>

<sgt-lead-endereco-form
    [entities]="entities"
    [isOpen]="isFormOpen"
    (save)="onFormSave($event)"
    (cancel)="onFormCancel()"
    #form>
</sgt-lead-endereco-form>
